import sendAjax from '../sendAjax';


export default {
  props: {
    api             : String,
    action          : String,
    entriesPerPage  : [Number, String],
    category        : String,
    categoryTotal   : [Number, String],
    initialContainer: String,
  },

  data() {
    return {
      newsList        : [],
      tabList         : [],
      moreExists      : true,
      isLoading       : false,
      nextId          : 0,
      perPage         : null,
      selectedCategory: '',
      total           : 0,
      hasErrors       : false,
      statusMsg       : '',
    };
  },

  created() {
    console.log('News Component: Created');
    this.selectedCategory = this.category;
    this.total            = this.normalizeInteger(this.categoryTotal, 1);
    this.perPage          = this.normalizeInteger(this.entriesPerPage, 9);

    if (!this.action) {
      throw new Error('News Component: Invalid param «action», should be not empty');
    }
  },

  mounted() {
    if (!this.parseInitialData()) {
      this.addNews();
    }
  },

  methods: {

    normalizeInteger(input, defaultValue) {
      let i = parseInt(input);
      return (isNaN(i) || i < 0) ? defaultValue : i;
    },

    parseInitialData() {
      let rootNode = document.getElementById(this.initialContainer || 'news');
      if (rootNode) {
        this.parseTabsData(rootNode);
        this.parseNewsData(rootNode);
        this.updateStateVisibleMoreButton();
        rootNode.innerHTML = '';
      }
      return !!rootNode;
    },

    parseTabsData(rootNode) {
      rootNode.querySelectorAll('.tab').forEach((item, index) => {
        let isActive = item.classList.contains('is-active');
        let total    = parseInt(item.dataset.total);
        let year     = item.dataset['year'];
        let title    = item.querySelector('.tab__title').innerText;

        this.tabList.push({id: index, title, year, total, isActive});

        if (isActive) {
          this.total            = total;
          this.selectedCategory = year;
        }
      });
      // console.log('TabsList: ', this.tabList);
    },

    parseNewsData(rootNode) {
      rootNode.querySelectorAll('.news-tile').forEach((item, index) => {
        let dateNode = item.querySelector('.news__date');
        let linkNode = item.querySelector('.news__link');
        this.newsList.push({
          id           : index,
          date         : dateNode.getAttribute('datetime'),
          formattedDate: dateNode.innerText,
          link         : linkNode.getAttribute('href'),
          title        : linkNode.innerText,
          text         : item.querySelector('.news__content').innerHTML,
        });
      });
      this.nextId = this.newsList.length;
      // console.log('NewsList: ', this.newsList);
    },

    loadNews(year, start, count) {

      this.resetErrors();
      this.isLoading = true;

      let fd = new FormData();
      fd.append('action', this.action);
      fd.append('year', year);
      fd.append('start', start);
      fd.append('count', count);

      return sendAjax(this.api, {
        body: fd,
      }).then(response => {
        console.log('Ajax response:', response);
        this.isLoading = false;
        return response;
      }).catch(error => {
        console.error(error);
        this.isLoading = false;
        this.statusMsg = error.message;
        this.hasErrors = true;
      });
    },

    addNews() {
      this.loadNews(this.selectedCategory, this.nextId, this.perPage)
          .then(response => {
            response['payload'].forEach(item => {
              this.newsList.push({
                id: this.nextId++,
                ...item,
              });
            });

            this.updateStateVisibleMoreButton();
          });
    },

    setActiveTab(id) {
      if (this.isLoading || this.tabList[id]['isActive']) return;

      let tabs = [];

      this.tabList.forEach((item, index) => {
        item.isActive = index === id;
        tabs.push(item);

        if (item.isActive) {
          this.total            = item.total;
          this.selectedCategory = item.year;
        }
      });

      this.loadNews(this.selectedCategory, 0, this.perPage)
          .then(response => {
            this.tabList = tabs;
            this.newsList.splice(0);

            setTimeout(() => {
              this.nextId = 0;
              response['payload'].forEach(item => {
                this.newsList.push({
                  id: this.nextId++,
                  ...item,
                });
              });

              this.updateStateVisibleMoreButton();
            }, 0);
          });
    },

    updateStateVisibleMoreButton() {
      this.moreExists = this.newsList.length < this.total;
    },

    resetErrors() {
      this.statusMsg = '';
      this.hasErrors = false;
    },
  },
};



// WEBPACK FOOTER //
// ./source/js/components/News/news.js